import store from '@/store';

export default class PauseTimeoutExpiredEvent {
  constructor(body) {
    window.console.log(
      '%c [event]',
      'color: #F44336;',
      JSON.stringify(body, null, 4),
    );
    const params = {
      agent_notify_time: new Date().getTime(),
      agent_notify_data1: body.pauseName,
      agent_notify_data2: body.channel,
      agent_notify_data3: body.agentId,
      agent_notify_read: 'N',
      agent_notify_read_display: 'N',
      agent_notify_type: 'pause',
      agent_notify_id: '_' + new Date().getTime(),
    };
    store.dispatch('notifications/appendPauseNotification', params);
  }
}
